import React from 'react';
import { AppBar, Stack, Skeleton } from '@mui/material';
import { Box, Typography } from '@mui/material';
import logo from 'url:../../../../assets/docsi_logo.svg';
import PrivacyPolicyBanner from './PrivacyPolicyBanner.jsx';
import { theme } from '../../../theme';

function HeadlineHeader({ physician }) {
    return (
        <AppBar position='sticky' sx={{ color: 'black', backgroundColor: theme.palette.background.white, boxShadow: 'none' }}>
            <Stack>
                <PrivacyPolicyBanner physician={physician} />
                <Stack direction="row" justifyContent="space-between" px={2} pt={3} pb={0} sx={{ backgroundColor: theme.palette.background.white }}>
                    <Stack>
                        <Box sx={{ fontSize: '22px'}} alignItems='center'>
                            { physician ? <Stack>
                                <Typography variant='normal'> Welcome </Typography>
                                <Typography variant='normal'> Dr. {physician.name}</Typography>
                            </Stack> : <Skeleton variant='text' width={175} /> }
                        </Box>
                        <Box py={1} sx={{ fontSize: '16px' }}>
                            { physician.organization ? <Typography variant='normal'>{physician.organization.name}</Typography> : <Skeleton variant='text' width={175} /> }
                        </Box>
                    </Stack>
                    <Box display='flex' alignItems='flex-start' maxWidth='40%'>
                        { physician.organization ? <img src={physician.organization.logo ? physician.organization.logo : logo} alt='Site Logo' style={{ objectFit: 'contain' }} width='100%' height={25}/> : <Skeleton variant='rectangle' width={150} height={20} /> }
                    </Box>
                </Stack>
            </Stack>
        </AppBar>
    );
}

export default HeadlineHeader;
